export const FETCH_WHITE_LABELLING = 'app/WhiteLabelling/FETCH_WHITE_LABELLING';
export const FETCH_WHITE_LABELLING_SUCCESS =
  'app/WhiteLabelling/FETCH_WHITE_LABELLING_SUCCESS';
export const FETCH_WHITE_LABELLING_FAILURE =
  'app/WhiteLabelling/FETCH_WHITE_LABELLING_FAILURE';

export const UPDATE_WHITE_LABELLING =
  'app/WhiteLabelling/UPDATE_WHITE_LABELLING';
export const UPDATE_WHITE_LABELLING_SUCCESS =
  'app/WhiteLabelling/UPDATE_WHITE_LABELLING_SUCCESS';
export const UPDATE_WHITE_LABELLING_FAILURE =
  'app/WhiteLabelling/UPDATE_WHITE_LABELLING_FAILURE';

export const NAV_BAR_BG_LABEL = 'Navigation Bar Background Colour:';
export const NAV_BAR_FONT_LABEL = 'Navigation Bar Text Colour:';
export const UI_CONTROL_BG_LABEL = 'UI Control Background Colour:';
export const UI_CONTROL_FONT_LABEL = 'UI Control Text Colour:';

export const LOGO_UPLOADER_ID = 'logo-uploader-id';
export const FAVICON_UPLOADER_ID = 'favicon-uploader-id';

export const LOGO_HELPER_TEXT = {
  supports: 'Supports .png, .jpg, .jpeg .svg under 500kb',
  recommended: '(Recommended: 370x100 pixels)',
};

export const FAVICON_HELPER_TEXT = {
  supports: 'Supports .ico, .png under 100kb',
  recommended: '(16x16 pixels)',
};
